import ReactDOM from 'react-dom';
import {
  ThemeProvider,
  Toast,
  ToastType,
} from '@alefeducation/ui-elements-library-core';

const showAutoHideToastOfType = (title: string, toastType: ToastType) => {
  return (
    <Toast
      autoHide
      content={{
        title: title,
        description: '',
      }}
      data-testid={`toast-${toastType}`}
      type={toastType}
    />
  );
};

const injectAutoHideToastOfType = (
  id: string,
  title: string,
  toastType: ToastType,
  description: string = '',
) => {
  return ReactDOM.render(
    <ThemeProvider>
      <Toast
        key={Math.random()}
        autoHide
        content={{
          title,
          description,
        }}
        data-testid={`toast-${toastType}`}
        type={toastType}
      />
    </ThemeProvider>,
    document.getElementById(id),
  );
};

export { showAutoHideToastOfType, injectAutoHideToastOfType };
